<template>
  <div class="wrapper">
    <div class="suggest">
      <div class="suggest__candidate">{{ $t('search.searchCandidates') }}:</div>
      <ul class="suggest__list">
        <li
          v-for="(suggest, index) in suggests"
          :key="`${suggest}-${index}`"
          class="suggest__list__candidate"
        >
          <div @click="searchBy(suggest)">
            {{ suggest }}
          </div>
        </li>
      </ul>
    </div>
    <div class="description">
      <p>{{ $t('search.searchDescription') }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    suggests: Array,
  },
  methods: {
    searchBy(suggest) {
      this.$emit('search-by-suggest', suggest)
    },
  },
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
ul,
li {
  margin-top: 0;
  margin-bottom: 0 !important;
}
.suggest {
  min-height: 40%;
  width: 100%;
  padding-top: 55px;
  background-color: #fff;
  overflow-x: scroll;
  &__candidate {
    float: left;
    padding: 10px 0 0 10px;
    box-sizing: border-box;
  }
  &__list {
    float: left;
    box-sizing: border-box;
    padding-left: 10px;
    padding-bottom: 10px;
    list-style: none;
    white-space: nowrap;
    overflow: scroll;
    > li {
      float: left;
      font-size: 0.85rem;
      margin-top: 10px;
      padding: 5px 10px;
    }
    &__candidate {
      display: block;
      background-color: #e7e7e7;
      border-radius: 5px;
      padding: 5px 15px;
      margin-right: 10px;
    }
  }
}
.description {
  margin-top: 10px;
  padding-bottom: 55px;
  font-size: 1.1rem;
  line-height: 1.7;

  p {
    white-space: pre-wrap;
  }
}
</style>
